import { FILE_835_VALIDATION_REASONS } from "../constants/ImportConversion835Constants";

/**
 * Builds specific, user-facing messages for files the Kendo Upload rejected.
 *
 * Kendo records why a file failed in `file.validationErrors` (for example
 * "invalidMaxFileSize") and renders only a generic sentence such as "File size too large."
 * next to the row. This maps those codes onto wording that names the offending file and
 * restates the actual limit, so the user knows which file to remove and why.
 *
 * A file can break more than one rule at a time, so each error code produces its own message.
 * Unrecognised codes are skipped rather than surfaced raw.
 *
 * @param {Array<{name?: string, validationErrors?: string[]}>} files Kendo upload file entries.
 * @returns {string[]} One message per file/error pair; empty when nothing is invalid.
 */
export function getFileValidationMessages(files) {
  if (!Array.isArray(files) || files.length === 0) {
    return [];
  }

  const messages = [];

  files.forEach((file) => {
    if (!file || !Array.isArray(file.validationErrors)) {
      return;
    }

    const fileName = file.name || "This file";

    file.validationErrors.forEach((errorCode) => {
      const reason = FILE_835_VALIDATION_REASONS[errorCode];

      if (reason) {
        messages.push(`${fileName} ${reason}`);
      }
    });
  });

  return messages;
}
